import { render, staticRenderFns } from "./milestone-carousel.vue?vue&type=template&id=5c5f93c0&scoped=true&"
import script from "./milestone-carousel.vue?vue&type=script&lang=ts&"
export * from "./milestone-carousel.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-carousel.vue?vue&type=style&index=0&id=5c5f93c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5f93c0",
  null
  
)

export default component.exports